import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Hero() {
  const {
    lang
  } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true
  });
  const isFR = lang === 'FR';
  return <section className="relative bg-white pt-40 lg:pt-52 pb-24 lg:pb-32 overflow-hidden" data-id="element-468">
      <div className="max-w-7xl mx-auto px-6 w-full" data-id="element-469">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center" data-id="element-470">
          {/* LEFT — content */}
          <div className="relative z-10" data-id="element-471">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8
          }} className="font-sans text-xs font-semibold tracking-[0.2em] text-[#121212]/50 uppercase mb-8" data-id="element-472">
              {isFR ? 'EN PRODUCTION DEPUIS 2017' : 'PROVEN SINCE 2017'}
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.1
          }} className="font-serif text-5xl md:text-6xl lg:text-[4rem] font-normal text-[#121212] leading-[1.1] tracking-tight mb-8" data-id="element-473">
              {isFR ? 'Faites plus. Sans agrandir votre équipe.' : 'Do More. Without Growing Your Team.'}
            </motion.h1>

            {/* Uniqueness line — the three pillars nobody else can claim */}
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="font-sans text-lg md:text-xl text-[#121212]/70 leading-relaxed max-w-xl mb-12" data-id="element-474">
              {isFR ? <>
                  La seule plateforme où{' '}
                  <span className="font-medium text-[#121212]" data-id="element-475">une identité vérifiée</span>,{' '}
                  <span className="font-medium text-[#121212]" data-id="element-476">une IA de confiance</span> et{' '}
                  <span className="font-medium text-[#121212]" data-id="element-477">la souveraineté des données au Canada</span>{' '}
                  transforment chaque demande en action.
                </> : <>
                  The only platform where{' '}
                  <span className="font-medium text-[#121212]" data-id="element-478">one verified identity</span>,{' '}
                  <span className="font-medium text-[#121212]" data-id="element-479">a trusted AI</span>, and{' '}
                  <span className="font-medium text-[#121212]" data-id="element-480">Canadian data sovereignty</span>{' '}
                  turn every request into action.
                </>}
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.3
          }} className="flex flex-wrap items-center gap-6" data-id="element-481">
              <Link to="/request-demo" className="flex items-center gap-2 px-8 py-4 bg-[#4F46E5] text-white text-sm font-medium uppercase tracking-wider hover:bg-[#4F46E5]/90 transition-colors" data-id="element-482">
                {isFR ? 'Demander une démo' : 'Request a Demo'}
                <ArrowRightIcon className="w-4 h-4" data-id="element-483" />
              </Link>
              <Link to="/demo" className="flex items-center gap-2 px-8 py-4 border border-[#E4E6EC] text-[#121212] text-sm font-medium uppercase tracking-wider hover:border-[#121212] transition-colors" data-id="element-484">
                {isFR ? 'Voir BCITI en action' : 'See BCITI in Action'}
              </Link>
            </motion.div>
          </div>

          {/* RIGHT — connected product ecosystem */}
          <div ref={ref} className="relative w-full mt-8 lg:mt-0 lg:origin-center lg:translate-x-[60px] lg:-mr-8 xl:-mr-20 lg:scale-[1.75] lg:p-12" data-id="element-485">
            <motion.img src={isFR ? 'https://cdn.magicpatterns.com/uploads/oKLkAuH3HkUrCbQ3tc1wfc/ChatGPT_Image_5_juil._2026,_13_41_13.png' : 'https://cdn.magicpatterns.com/uploads/a41wMEC1QaGoFm6BSmtRJn/ChatGPT_Image_5_juil._2026,_13_11_42.png'} alt={isFR ? 'Écosystème connecté BCITI : site web, portail citoyen, tableau de bord et application mobile reliés par ATNA.' : 'BCITI connected ecosystem: website, citizen portal, dashboard and mobile app linked by ATNA.'} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.9,
            ease: 'easeOut'
          }} className="w-full h-auto object-contain" data-id="element-486" />
          </div>
        </div>
      </div>
    </section>;
}